import axios from 'axios';
import Cookies from 'js-cookie';

export const getAlertsData = (path = '', params = {}, signal) => axios.get(
    `${import.meta.env.VITE_BASEURL}/get/alerts${path}`,
    { params, signal, timeout: 30000, headers: { Authorization: `Bearer ${Cookies.get('auth_token')}` } }
).then(response => response.data);

// A manual write request: no retry interceptor and no automatic caller.
export const processRPMTempAlert = body => axios.post(
    `${import.meta.env.VITE_BASEURL}/post/alerts/rpm-temp/process`, body,
    { timeout: 60000, headers: { Authorization: `Bearer ${Cookies.get('auth_token')}` } }
).then(response => response.data);
